import { NewMessageFormData } from '@src/main/modules/messages/ui/mailbox/components/new-message/types/NewMessageFormData';
import { FleetTimeOption } from '@src/main/modules/messages/ui/mailbox/model/fleet-time-option.model';
import { MultiSelect } from 'primereact/multiselect';
import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';

interface SubfleetsFieldProps {
  control: Control<NewMessageFormData>;
  fleetOptions: FleetTimeOption[];
  t: (key: string) => string;
  styles: Record<string, string>;
}

const SubfleetsField: FC<SubfleetsFieldProps> = ({ control, fleetOptions, t, styles }) => (
  <div className={styles['form-section']}>
    <Controller
      name="fleets"
      control={control}
      render={({ field, fieldState }) => (
        <div className="p-field">
          <label htmlFor="fleets">{t('messages.mailbox.recipientTypes.subfleet.label')}</label>
          <MultiSelect
            id="fleets"
            value={field.value || []}
            options={fleetOptions}
            onChange={(e) => field.onChange(e.value)}
            optionValue="raw"
            optionLabel="label"
            placeholder="Selecciona subflotas"
            display="chip"
            className={fieldState.invalid ? 'p-invalid' : ''}
          />
          {fieldState.error && <small className="p-error">{fieldState.error.message}</small>}
        </div>
      )}
    />
  </div>
);

export default SubfleetsField;
